import { ReactNode, ReactNodeArray } from '../react';

type EmptyComponentProps = {
   readonly children?: ReactNode | ReactNodeArray;
};

export const EmptyComponent = (props: EmptyComponentProps): JSX.Element => {
   return <>{props.children}</>;
};
